import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massRestoreContacts } from '../../api/apiContacts';
import toast from 'react-hot-toast';

export const useRestoreAllContacts = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ items }) => massRestoreContacts(items || []),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['contacts'] });
            toast.success(data.message || 'Messages restored successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to restore messages';
            toast.error(errorMessage);
        },
    });
};